
import { BasicModel } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { Keyboard } from "@goodgamestudios/createjs-utilities";
import { KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2GiveChipsEvent } from "../../../event/Poker2GiveChipsEvent";
import { Poker2SliderEvent } from "../../../event/Poker2SliderEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2GiveChipsConfigDialogProperties } from "./Poker2GiveChipsConfigDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2GiveChipsConfigDialog extends Poker2Dialog {
    private static BIG_BLIND_STEP_FACTOR: number = 10;
    public static NAME: string = "Poker2GiveChipsConfigDialog";
    private _slider: SliderHelperStepper;
    private _stepSizeNumeric: number = NaN;
    private _sliderValue_START: number = NaN;
    private _sliderValue_MIN: number = NaN;
    private _sliderValue_MAX: number = NaN;
    private _txtTitleStep2: string;
    private _txtCopyStep2: string;
    private _sliderRange: number = NaN;

    /**
     * This dialog allows the user to adjust the amount of chips he wants to give the chosen receiver.
     * @param disp
     */
    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);

        this.hasLightBoxBehaviour = true;
    }

    protected init(): void {
        super.init();
        this._slider = new SliderHelperStepper(this.giveChipsConfigMc.slider);
        this.giveChipsConfigMc.mc_input.txt_input.restrict = "0-9";
        this.giveChipsConfigMc.mc_input.txt_input.maxChars = 9;
        this.initTextFields();
        this.giveChipsConfigMc.visual._1.allowFastGlow = false;
        this.giveChipsConfigMc.visual._1.doCache();
    }

    private initTextFields(): void {
        this.giveChipsConfigMc.btn_give.label = Poker2Model.languageData.getTextById("dialog_pesentreminder_send");
        this.giveChipsConfigMc.txt_title.text = Poker2Model.languageData.getTextById("dialog_profilecard_sendChips");
    }

    protected applyProperties(): void {
        // find out the name of the chip receiver
        var receiverName: string = this.getChipReceiverName(this.giveChipsConfigDialogProperties.playerId);

        this._sliderValue_MIN = this.giveChipsConfigDialogProperties.chipsToGive * 0.1;
        this._sliderValue_MAX = MathBase.min(this.giveChipsConfigDialogProperties.chipsToGive, Poker2Model.userData.userCash);
        this._sliderRange = this._sliderValue_MAX - this._sliderValue_MIN;
        this._sliderValue_START = this._sliderValue_MIN + Math.round((this._sliderRange) * .5);

        // check if controls have to be enabled
        var enableControls: boolean = false;
        if (Poker2Model.userData.userCash >= this._sliderValue_MIN) {
            enableControls = true;

            this.giveChipsConfigMc.slider.visible = enableControls;
            if (Poker2Model.userData.userCash == this._sliderValue_MIN) {
                this.giveChipsConfigMc.slider.visible = false;
            }
        }

        this.giveChipsConfigMc.btn_give.enableButton = enableControls;
        this.giveChipsConfigMc.mc_input.visible = enableControls;
        this.giveChipsConfigMc.mc_input.txt_input.text = this._sliderValue_START.toString();
        this.giveChipsConfigMc.mc_input.txt_input.maxChars = 4;

        // calculate numeric step size
        this._stepSizeNumeric = Math.round(this._sliderRange / 10);
        // initialize stepwise slider
        this._slider.initSliderStepper(this._sliderValue_MIN, this._sliderValue_MAX, this._stepSizeNumeric, this._sliderValue_START, this.giveChipsConfigMc.mc_input.txt_input);

        var copy: string;
        if (Poker2Model.userData.userCash < this._sliderValue_MIN) {
            // user cash is to low to give chips
            copy = Poker2Model.languageData.getTextById("errorcode_10");
        }
        else {
            copy = Poker2Model.languageData.getTextById("dialog_profilcard_sendChips_copy", [receiverName]);
        }

        //			TextFieldHelper.changeTextFromatSizeByTextWidth( 15, giveChipsConfigMc.txt_copy, copy );
        this.giveChipsConfigMc.txt_copy.text = copy;
    }

    private getChipReceiverName(playerId: number): string {
        var name: string;

        switch (Poker2LayoutManager.getInstance().currentState) {
            case 10:

                name = this.giveChipsConfigDialogProperties.playerName;
                break;

            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 17:

                name = Poker2Model.buddyList.getBuddyByPlayerId(playerId).playerName;
                break;
        }

        return name;
    }

    public show(): void {
        super.show();
        this.giveChipsConfigMc.slider.addEventListener("onSliding", this.bindFunction(this.onSliding));
        this.giveChipsConfigMc.slider.addEventListener("slideUp", this.bindFunction(this.onSliding));
        this.giveChipsConfigMc.slider.addEventListener("slideDown", this.bindFunction(this.onSliding));
    }

    public hide(): void {
        super.hide();
        this.giveChipsConfigMc.slider.removeEventListener("onSliding", this.bindFunction(this.onSliding));
        this.giveChipsConfigMc.slider.removeEventListener("slideUp", this.bindFunction(this.onSliding));
        this.giveChipsConfigMc.slider.removeEventListener("slideDown", this.bindFunction(this.onSliding));
    }

    private killSlider(): void {
        if (this._slider) {
            this._slider.destroy();
            this._slider = null;
        }
    }

    public destroy(): void {
        super.destroy();
        this.killSlider();
    }

    protected onKeyUp(event: KeyboardEvent): void {
        if (event.keyCode == Keyboard.ENTER) {
            var inputtedChipValue: number = MathBase.max(this._sliderValue_MIN, MathBase.min(this._sliderValue_MAX, parseFloat(this.giveChipsConfigMc.mc_input.txt_input.text)));
            this.giveChipsConfigMc.mc_input.txt_input.text = String(inputtedChipValue);

            var enableGiveButton: boolean = false;
            // Check if user can afford the chips to give.
            if (Poker2LayoutManager.getInstance().currentState == 10) {
                // check if the user cash is enough for the inputted chip amount + the table fee
                enableGiveButton = inputtedChipValue + Poker2Model.onTableData.currentTable.sBlind <= Poker2Model.userData.userCash;
            }
            else {
                enableGiveButton = inputtedChipValue <= Poker2Model.userData.userCash;
            }
            this.giveChipsConfigMc.btn_give.enableButton = enableGiveButton;
        }
    }

    private onSliding(event: Poker2SliderEvent): void {
        // ignore changes to binded input fields to slider
        if (event.onInputFieldChanged) {
            return;
        }

        var result: string;
        if (event.type == "slideUp" || event.type == "slideDown") {
            // take stepwise values from SliderStepper component
            result = event.numericValue.toString();
        }
        else {
            // calulates stepless values
            result = String(Math.round(this._sliderValue_MIN + ((this._sliderValue_MAX - this._sliderValue_MIN) * event.percentValue / 100)));
        }

        // show result
        this.giveChipsConfigMc.mc_input.txt_input.text = result;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        var paramObject: any = {};

        switch (event.target) {
            case this.giveChipsConfigMc.btn_close:
                this.hide();
                break;
            case this.giveChipsConfigMc.btn_give:
                if (this.giveChipsConfigMc.btn_give.enabled) {
                    var validChipsToGive: number = MathBase.max(this._sliderValue_MIN, MathBase.min(this._sliderValue_MAX, parseFloat(this.giveChipsConfigMc.mc_input.txt_input.text)));

                    // update input textfield
                    if (this.giveChipsConfigMc.mc_input.txt_input.text != String(validChipsToGive)) {
                        this.giveChipsConfigMc.mc_input.txt_input.text = String(validChipsToGive);
                    }
                    else {
                        //
                        this.controller.dispatchEvent(new Poker2GiveChipsEvent("chipsSent"));

                        // send server event
                        paramObject = { pid: this.giveChipsConfigDialogProperties.playerId, chips: validChipsToGive };
                        BasicModel.smartfoxClient.sendMessage("vgc", [JSON.stringify(paramObject)]);

                        // hide
                        this.hide();
                    }
                }
                break;
        }
    }

    protected get giveChipsConfigDialogProperties(): Poker2GiveChipsConfigDialogProperties {
        return this.properties as Poker2GiveChipsConfigDialogProperties;
    }

    protected get giveChipsConfigMc(): Library.PokerInterface.PokerGiveChipsConfig {
        return this.disp as Library.PokerInterface.PokerGiveChipsConfig;
    }
}
import { SliderHelperStepper } from "../../helper/SliderHelperStepper";
import { Poker2LayoutManager } from "../../Poker2LayoutManager";
